<div class="padding">
  <mat-spinner></mat-spinner>
      <h1 class="dashboard-title">Estamos verificando su información</h1>
      <h2 class="dashboard-description">Por favor, espere unos momentos</h2>
</div>
